<template>

  <div id="layout-attente">
    <TopBar/>
    <Notification/>
    <AppHeaderCheckout/>
    <slot/>
    <transition name="sf-fade">
      <div v-show="scY > 300" id="pagetop" @click="toTop">
        <SfIcon :icon="icons.up.path" :view-box="icons.up.viewBox"></SfIcon>
      </div>
    </transition>
  </div>

</template>

<script>
import AppHeaderCheckout from '@/components/AppHeader-Checkout';

import Notification from "@/components/Notification";
import TopBar from "@/components/TopBar";
import {SfIcon} from "@storefront-ui/vue"
import icons from "@/utils/icons";

export default {
  components: {
    TopBar,
    SfIcon,
    AppHeaderCheckout,
    Notification,

  },
  data() {
    return {
      scTimer: 0,
      scY: 0,
      icons: icons
    }
  }, mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
  },
};
</script>
